import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DTFHomepageService } from '../dtfhomepage/dtfhomepage.service';
import { AuthorizationService } from '../authorization/authorization.service';
import { WindowRef } from '../../utils/window';
import { TranslateService } from '@ngx-translate/core';
import { Banner } from '../../shared/models/banner';
import { TranslateUtil } from '../../utils/translate-util';
import { APP_CONSTANTS } from '../../utils/app-constants';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { AgreementDetailsList } from '../../shared/models/AgreementDetailsList';
import { SelectionModel } from '@angular/cdk/collections';
import { ContractNumberRequest } from '../../shared/models/contractNumberResponse';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle} from '@angular/material/dialog';
import { AutoPaySignUpBeanList } from '../../shared/models/AutoPaySignUpBeanList';

import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { SharedTranslateModule } from '../../utils/sharedTranslateModule';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { SessionTimeoutComponent } from '../sessionTimeout/sessionTimeout.component';
import { BankAccountValidationRequest } from '../utils/bank-account-validation-request';

export enum AutoPayEnum { //used for mat toggle
  Signup,
  Edit,
  Terminate,
  None
}

@Component({
    selector: 'div.dtf-autoPay',
    templateUrl: './autoPay.component.html',
    imports: [SharedTranslateModule,
        MatPaginator, MatSort, MatTableModule, SessionTimeoutComponent, MatCheckboxModule, MatFormFieldModule, MatIconModule, MatMenuModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatSortModule
    ],
    providers: [],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ]
})


export class AutoPayComponent implements OnInit {
  title = 'Content Section of the Page';
  router: Router;
  path = '';
  loginRedirect = '';
  accountRedirect = '';
  password2 = '';
  password3 = '';
  reTypePassword = '';
  token: string;
  brandId: string;
  hideSingleSelectionIndicator=true;
  action = '';
  loginAttempt = false;
  isLoginattempt = '';
  enrollFlagFromDB: string;
  countryFlag: string;
  langFlag: string;
  currentCountry: string;
  isCanadaPortal = false;
  baseUrl = '';
  currentPassword = '';
  currentPasswordDBCheckFlag = false;
  usUrl: string;
  caUrl: string;
  azURL: string;
  agentview: string;
  agentId: string;
  bodyLoaded = false;
  dbLoaded = false;
  isFrench = false;
  managePassword = false;
  passwordReset = false;
  hasUpperCase = false;
  hasLowerCase = false;
  hasNumeric = false;
  hasMinimum = false;
  hasMaximum = false;
  userIDcheck = false;
  reentercheck = false;
  confirmReset = false;
  confirmEnroll = false;
  confirmTerminate = false;
  confirmEbillReset = false;
  reentermailcheck = false;
  confirmMailReset = false;
  password = '';
  hide = false;
  hide1 = false;
  hide2 = false;
  passwordRequest: any = {};
  EmailRequest: any = {};
  EbillRequest: any = {};
  isPcAutopayEnabledRequest: any = {};
  getBankProfileDetailsforAutopayAccountsRequest: any = {};
  getValidAutopayAccountsRequest: any = {};
  openLoginModal = false;
  serviceErrorOccurred = false;
  serviceErrorDesc = '';
  userId = '';
  dbData: any;
  public alerts: Banner;
  toggleOpen: any;
  recAccCount = '';
  totalDue = '';
  language = '';
  emailOffers = true;
  isReset = false;
  userExist = false;
  marked = false;
  // theCheckbox = true;
  ciamId = sessionStorage.getItem('loginID');
  emailAddress = sessionStorage.getItem('emailAddress');
  customerName =  sessionStorage.getItem('customerName');
  thirdPartyNumber = sessionStorage.getItem('thirdPartyNumber');
  agreementDetailsList: AgreementDetailsList[];
  contractNumberList: ContractNumberRequest[];
  contract: ContractNumberRequest;
  autoPaySignUpBeanList: AutoPaySignUpBeanList[]; 
  AutoPaySignUpBean: AutoPaySignUpBeanList;
    validateBankProfile: BankAccountValidationRequest = new BankAccountValidationRequest;
  
  displaycontractNumberList ='';
  bankProfileForm: FormGroup;
  SelectAutopay = false;
  isAP = false;
  isPC = false;
  SelectAutopaySignup = false;
  SelectAutopayEdit = false;
  SelectAutopayTerminate = false;
  tableLoaded = true;
  disabledFlag =false;
  dataLoaded=false;
  CANCEL = '';
  selectBankProfile = false;
  selectBankVerification = false;
  selectTerminate=false;
  accountValid = false;
  routingValid=false;
  routingNumber ='';
  ownerLeseeName ='';
  bankName ='';
  bankAccountNumber ='';
  maskedBankAccountNumber='';
  unmaskedAccountNumber ='';
  nameOnBankAccount ='';
  pymtOption='';
  displaypymtOption = '';
  bankAccountNumberConfirmation ='';
  billingId ='';
  AccountType: string;
  DisplayAccountType: string;
  AutopayType:string;
  signUp = false;
  editFlag = false;
  contractSelected = false;
  ValidationErrors = false;
  AutopayRequest = {};
  AutopayConfirmRequest= {};
  AutopayTerminateRequest = {};
  // check_box_eBill = CheckeBill;
  // currentlyChecked: CheckeBill;
  // checkeBill = CheckeBill;
  // selectedEbill = CheckeBill.NONE;

  //used for mat-toggle
  toggleAutoPayEnum = AutoPayEnum;
  selectedAutopayState = AutoPayEnum.None;


  // Table columns
  initColumns: any[] = [
    {
      name: 'select',
      display: '',
      displayMobile: '',
      displayFR: '',
      dispFormat: ''
    },
    {
      name: 'agreementNumber',
      display: 'Contract',
      displayFR: 'Numéro de contrat',
      dispFormat: ''
    },
    {
      name: 'effectiveDate',
      display: 'Effective Date',
      displayFR: 'Effective Date',
      dispFormat: ''
    }
  ];
  displayedColumns: any[] = this.initColumns.map(col => col.name);

  filterActive = false;
  filter = false;
  rowCount = 0;
  value = '';


  dataSource: MatTableDataSource<AgreementDetailsList>;
  singledataSource: MatTableDataSource<AgreementDetailsList>;



  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  selection = new SelectionModel<AgreementDetailsList>(true, []);
  selectionsingle = new SelectionModel<AgreementDetailsList>(false, []);

  constructor(router: Router, private dtfhomepageService: DTFHomepageService, private fb: FormBuilder, public auth: AuthorizationService,
    private _window: WindowRef, public translate: TranslateService, public translateUtil: TranslateUtil,public dialog: MatDialog

  ) {
    this.router = router;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
    this.agreementDetailsList = [];
    this.autoPaySignUpBeanList = [];
    this.dataSource = new MatTableDataSource(this.agreementDetailsList);
  }

  ngAfterViewInit() {
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.rowCount = this.dataSource.filteredData.length;
  }

  onChangeAutopayButton($event) { //Used for mat-toggle conditions to filter DB
    this.selectedAutopayState = $event.value;
    this.disabledFlag = false;
    this.SelectAutopaySignup = false;
    this.SelectAutopayEdit = false;
    this.SelectAutopayTerminate = false;
    this.contractNumberList =[];
    this.AutopayType ='';
    this.AccountType ='';
    this.DisplayAccountType = '';
    this.pymtOption='';
    this.routingNumber = '';
    this.ownerLeseeName = '';
    this.bankAccountNumber = '';
    this.nameOnBankAccount = '';
    this.billingId = '';
    this.bankAccountNumberConfirmation = '';
    this.signUp = false;
    this.AutopayTerminateRequest ={};
    this.AutopayConfirmRequest={};
    this.editFlag = false;
    
    if (this.selectedAutopayState === 0) {
      this.getValidAutopayAccounts(true, false,'signUp');
    }
    else if (this.selectedAutopayState === 1) {
      this.getValidAutopayAccounts(false, true,'edit');
    }
    else if (this.selectedAutopayState === 2) {
      this.getValidAutopayAccounts(false, true,'terminate');
    }      
  }

  ngOnInit() {
    sessionStorage.removeItem('autopaydialog');
    this.agentview = sessionStorage.getItem('agentview');
    this.agentId = sessionStorage.getItem('agentID');
    const language = (window as any).mbfs.language;
    this.language= language;
    const country = (window as any).mbfs.country;
    this.countryFlag = country;
    this.langFlag = language;
    this.brandId = sessionStorage.getItem('brandId');
    this.token = sessionStorage.getItem('ciamToken');

    this.translateUtil.setCountryAndLangFromUIProp();
    this.translateUtil.getCurrentCountry().subscribe(val => {
      this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
      this.currentCountry = val;
    });
    this.isFrench = ('fr-CA' === language) ? true : false; //checks if language is french or english for Canada

    this.isPcAutopayEnabled();
    //this.getAlerts();
    let element: HTMLElement = document.getElementById('auto_triggerautopay') as HTMLElement;
    element.click();
  }

 

  checkUrl(redirect: string) {
    this.isLoginattempt = sessionStorage.getItem('loginAttempt');
    sessionStorage.setItem('classicredirect', 'yes');
      this.formatAccountURl(redirect);
  }

  checkUrlParam(redirect: string, account: string) {
    this.isLoginattempt = sessionStorage.getItem('loginAttempt');
    sessionStorage.setItem('amortAccount', account);
    sessionStorage.setItem('classicredirect', 'yes');
    this.formatAccountURl(redirect);
  }
  anouncementMgsopen(e: any) {
    e.preventDefault();
    if (this.toggleOpen) {
      this.toggleOpen = false;
    } else {
      this.toggleOpen = true;
    }
  }

  // getAlerts() {
  //   this.dtfhomepageService.getAlerts().subscribe((res) => {
  //     for (var i = 0; i < res.length; i++) {
  //       if (this.currentCountry === 'CA') {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerName.indexOf((this.langFlag)) !== -1 &&
  //           res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'CA') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //       else {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'US') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //     }
  //   });
  // }

  formatAccountURl(redirect: string) {
    this.bodyLoaded = true;
    window.scrollTo(0, 0); // used to scroll to top of page
    if (this.countryFlag === 'CA') //CA Logic
    {
      this.azURL = this.accountRedirect + '?blink=' + redirect;
      if (this.langFlag === 'fr-CA') {
        if (redirect === 'insurance') {
          this.azURL = this.usUrl + '/ca/fr/home/insurance';
        }
        else if (redirect === 'amortization') {
          this.azURL = this.usUrl + '/ca/fr/home/amortization';
        }
        else if (redirect === 'documentcenter') {
          this.azURL = this.usUrl + '/ca/fr/home/documentcenter';
        }
      }
      else {
        if (redirect === 'insurance') {
          this.azURL = this.usUrl + '/ca/en/home/insurance';
        }
        else if (redirect === 'amortization') {
          this.azURL = this.usUrl + '/ca/en/home/amortization';
        }
        else if (redirect === 'documentcenter') {
          this.azURL = this.usUrl + '/ca/en/home/documentcenter';
        }
      }
    }
    else { //US Logic
      this.azURL = this.accountRedirect + '?blinkImage=null&blink=' + redirect;

      if (redirect === 'insurance') {
        this.azURL = this.usUrl + '/home/insurance';
      }
      else if (redirect === 'amortization') {
        this.azURL = this.usUrl + '/home/amortization';
      }
      else if (redirect === 'documentcenter') {
        this.azURL = this.usUrl + '/home/documentcenter';
      }
      else if (redirect === 'invoice') {
        this.azURL = this.usUrl + '/home/invoice';
      }
    }
    setTimeout(() => {
      this._window.nativeWindow.location.href = this.azURL;
    }, 1000);  //1s
  }

  formValidationClasses = {
    'mbfs-error': true,
  };
  buildForm() {
    this.bankProfileForm = this.fb.group({
      routingNumber: [''],
      ownerLeseeName: [''],
      bankName: [''],
      bankAccountNumber: [''],
      nameOnBankAccount: [''],
      bankAccountNumberConfirmation: [''],
      AccountType: [''],
      AutopayType: ['']
    });
  }

  onClickAutoPay(e: Event): void {
    this.buildForm();
    this.openLoginModal = true;

    this.bankProfileForm.get('routingNumber').setValidators(
      Validators.compose([Validators.required])
    );
    this.bankProfileForm.get('ownerLeseeName').setValidators(
      Validators.compose([Validators.required])
    );
    this.bankProfileForm.get('bankName').setValidators(
      Validators.compose([Validators.required])
    );
    this.bankProfileForm.get('bankAccountNumber').setValidators(
      Validators.compose([Validators.required])
    );
    this.bankProfileForm.get('nameOnBankAccount').setValidators(
      Validators.compose([Validators.required])
    );
    this.bankProfileForm.get('bankAccountNumberConfirmation').setValidators(
      Validators.compose([Validators.required])
    );
    // this.bankProfileForm.get('currentPassword').setValidators(
    //   Validators.compose([Validators.required])
    // );
    this.bankProfileForm.get('AccountType').setValidators(
      Validators.compose([Validators.required])
    );
    this.bankProfileForm.get('AutopayType').setValidators(
      Validators.compose([Validators.required])
    );    
  }

  getDashBoardDetails(dashBoardRequest) {
    this.auth.getDashBoardDetails(dashBoardRequest).subscribe(res => {
      this.recAccCount = res.recAccCount;
      this.totalDue = res.totalDue;
      if (this.totalDue.includes("-")) {
        this.totalDue = "0.00";
      }
    });
  }

  closeCIAMModal(e: Event) {
    this.openLoginModal = false;
    this.userExist = false;
    this.isReset = false;
    this.serviceErrorOccurred = false;
  }

  isPcAutopayEnabled(){
    sessionStorage.removeItem('skipterminate');
    this.isPcAutopayEnabledRequest = {};
    this.isPcAutopayEnabledRequest = {
      ciamId: this.ciamId,
      ciamAZCode: this.token,
    };
    this.auth.isPcAutopayEnabled(this.isPcAutopayEnabledRequest).subscribe(res => {
      if (res.statusMessage === 'SUCCESS') {
        this.isAP = res.autoPayEnabled;
        this.isPC = res.pcenabled;
        this.SelectAutopay = true; 
        this.dataLoaded=true;
      }
});
  }

  getValidAutopayAccounts(signUp : boolean , editFlag : boolean, page:any){
    this.contractSelected = false;
    this.signUp = signUp;
    this.editFlag = editFlag;
    this.getValidAutopayAccountsRequest = {};
    this.getValidAutopayAccountsRequest = {
      signUp : signUp,
      editFlag: editFlag,
      ciamId: this.ciamId,
      ciamAZCode: this.token,
    };
    this.auth.getValidAutopayAccounts(this.getValidAutopayAccountsRequest).subscribe(res => {
      if (res.statusMessage === 'SUCCESS') {
        this.agreementDetailsList = res.agreementDetailsList;
        this.dataSource = new MatTableDataSource(this.agreementDetailsList);
        setTimeout(()=>{
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.dataSource.filterPredicate = function(data, filter: string): boolean {
            return data.agreementNumber.toLowerCase().includes(filter) || data.effectiveDate.toLowerCase().includes(filter);
          };
          this.dbLoaded = true;
          this.filter = true;
          this.rowCount = this.dataSource.filteredData.length;
      });
    if(page === 'signUp'){
      this.ownerLeseeName = this.customerName;
      this.SelectAutopaySignup = true;
    }
    else if(page === 'edit'){
      this.ownerLeseeName = this.customerName;
      this.SelectAutopayEdit = true;
    }
    else if(page === 'terminate'){
      this.ownerLeseeName = this.customerName;
      this.SelectAutopayTerminate = true;
    }
    }
      
    });

  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  public disableCheckboxSingle(): boolean {
    return this.selectionsingle.selected.length >= 1;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.data.forEach(row => this.selection.select(row));
  }

  checkToggleSelected(){
    this.contractNumberList = [];
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    if(numSelected < 1){
      sessionStorage.setItem('autopaydialog', 'error');
      this.auth.SetErrorMessage('Please select at least one account');
      this.openDialog(5);
      this.contractSelected = false;
        }
    else if(numSelected > 10){
      sessionStorage.setItem('autopaydialog', 'error');
      this.auth.SetErrorMessage('Please select at less than 10 account(s)');
      this.openDialog(5);
      this.contractSelected = false;
      }
    else{
      this.contractSelected = true;
    }
    for (var i = 0; i < this.selection.selected.length; i++) {
      this.contract = new ContractNumberRequest();
      this.contract.contractNumber = this.selection.selected[i].agreementNumber;
      this.contract.scheduleNumber = 1;
      this.contract.effectiveDate = this.selection.selected[i].effectiveDate;
      this.contractNumberList.push(this.contract);
    }
    return true;
   }

   checkSingleToggleSelected(){
    this.contractNumberList = [];
    const numSelected = this.selectionsingle.selected.length;
    const numRows = this.dataSource.data.length;
    if(numSelected < 1){
      sessionStorage.setItem('autopaydialog', 'error');
      this.auth.SetErrorMessage('Please select at least one account');
      this.openDialog(5);
      this.contractSelected = false;
        }
    else{
      this.contractSelected = true;
    }
    for (var i = 0; i < this.selectionsingle.selected.length; i++) {
      this.contract = new ContractNumberRequest();
      this.contract.contractNumber = this.selectionsingle.selected[i].agreementNumber;
      this.contract.scheduleNumber = 1;
      this.contract.effectiveDate = this.selectionsingle.selected[i].effectiveDate;
      this.contractNumberList.push(this.contract);
    }
   }

   openAutoPayPopup(){
    this.checkToggleSelected(); //checks select Box
    if(this.contractSelected){
    this.auth.SetObjData(this.contractNumberList);
    this.getBankProfileDetailsforAutopayAccounts('signup');
    }
   }

   openAutoPayEdit(){
    this.checkSingleToggleSelected(); //checks select Box
    if(this.contractSelected){
    this.auth.SetObjData(this.contractNumberList);
    this.getBankProfileDetailsforAutopayAccounts('edit');
  }
   }

   openAutoPayTerminate(){
    this.checkToggleSelected(); //checks select Box
    if(this.contractSelected){
    this.auth.SetObjData(this.contractNumberList);
    this.getBankProfileDetailsforAutopayAccounts('terminate');
    }
   }

   openBankWarning(){
    this.ValidationErrors = false;
    this.routingNumber = this.bankProfileForm.get('routingNumber').value;
    this.ownerLeseeName =this.bankProfileForm.get('ownerLeseeName').value;
    this.bankAccountNumber =this.bankProfileForm.get('bankAccountNumber').value;
    this.nameOnBankAccount =this.bankProfileForm.get('nameOnBankAccount').value;
    this.bankAccountNumberConfirmation =this.bankProfileForm.get('bankAccountNumberConfirmation').value;
    this.AccountType = this.bankProfileForm.get('AccountType').value;
    this.DisplayAccountType =  this.AccountType.replace(/_/g, ' ');
    this.AutopayType = this.bankProfileForm.get('AutopayType').value;

    if(!this.routingNumber){
      this.ValidationErrors = true;
      sessionStorage.setItem('autopaydialog', 'error');
      this.auth.SetErrorMessage('Routing Number is Missing');
      this.openDialog(5);
    }
   else if(!this.routingValid){
      this.ValidationErrors = true;
      sessionStorage.setItem('autopaydialog', 'error');
      this.auth.SetErrorMessage('Routing Number is Invalid');
      this.openDialog(5);
    }
    else if(!this.AccountType){
      this.ValidationErrors = true;
      sessionStorage.setItem('autopaydialog', 'error');
      this.auth.SetErrorMessage('Account Type (Checking/Savings) is Missing');
      this.openDialog(5);
    }
    else if (!this.nameOnBankAccount){
      sessionStorage.setItem('autopaydialog', 'error');
      this.auth.SetErrorMessage('Name On Bank Account is Missing');
      this.openDialog(5);
    }
    else if(!this.bankAccountNumber ){
      this.ValidationErrors = true;
      sessionStorage.setItem('autopaydialog', 'error');
      this.auth.SetErrorMessage('Bank Account Number is Missing');
      this.openDialog(5);
    }
    else if(!this.accountValid){
      this.ValidationErrors = true;
      sessionStorage.setItem('autopaydialog', 'error');
      this.auth.SetErrorMessage('Bank Account Number is Invalid');
      this.openDialog(5);
    }
    else if(!this.bankAccountNumberConfirmation){
      this.ValidationErrors = true;
      sessionStorage.setItem('autopaydialog', 'error');
      this.auth.SetErrorMessage('Bank Account Confirmation Number is Missing');
      this.openDialog(5);
    }
    else if (this.bankAccountNumber != this.bankAccountNumberConfirmation) {
      this.ValidationErrors = true;
      sessionStorage.setItem('autopaydialog', 'error');
      this.auth.SetErrorMessage('Bank Account Number / Confirmation do not match');
      this.openDialog(5);
    }
    else if(!this.ownerLeseeName){
      this.ValidationErrors = true;
      sessionStorage.setItem('autopaydialog', 'error');
      this.auth.SetErrorMessage('Owner/Lesee Name is Missing');
      this.openDialog(5);
    }
    else if(!this.AutopayType){
      this.ValidationErrors = true;
      sessionStorage.setItem('autopaydialog', 'error');
      this.auth.SetErrorMessage('Digital Type (Yes/No) is Missing');
      this.openDialog(5);
    }
    else{
      sessionStorage.setItem('autopaydialog', 'two');
      this.openDialog(2);
    }
   }

   editValidations(){
    this.ValidationErrors = false;
    this.routingNumber = this.bankProfileForm.get('routingNumber').value;
    this.ownerLeseeName =this.bankProfileForm.get('ownerLeseeName').value;
    this.bankAccountNumber =this.bankProfileForm.get('bankAccountNumber').value;
    this.nameOnBankAccount =this.bankProfileForm.get('nameOnBankAccount').value;
    this.bankAccountNumberConfirmation =this.bankProfileForm.get('bankAccountNumberConfirmation').value;
    this.AccountType = this.bankProfileForm.get('AccountType').value;
    this.DisplayAccountType =  this.AccountType.replace(/_/g, ' ');
    if(!this.routingNumber){
      this.ValidationErrors = true;
      sessionStorage.setItem('autopaydialog', 'error');
      this.auth.SetErrorMessage('Routing Number is Missing');
      this.openDialog(5);
    }
   else if(!this.ownerLeseeName){
      this.ValidationErrors = true;
      sessionStorage.setItem('autopaydialog', 'error');
      this.auth.SetErrorMessage('Owner/Lesee Name is Missing');
      this.openDialog(5);
    }
    else if (!this.nameOnBankAccount){
      sessionStorage.setItem('autopaydialog', 'error');
      this.auth.SetErrorMessage('Name On Bank Account is Missing');
      this.openDialog(5);
    }
    else if(!this.bankAccountNumber ){
      this.ValidationErrors = true;
      sessionStorage.setItem('autopaydialog', 'error');
      this.auth.SetErrorMessage('Bank Account Number is Missing');
      this.openDialog(5);
    }
    else if(!this.bankAccountNumberConfirmation){
      this.ValidationErrors = true;
      sessionStorage.setItem('autopaydialog', 'error');
      this.auth.SetErrorMessage('Bank Account Confirmation Number is Missing');
      this.openDialog(5);
    }
    else if (this.bankAccountNumber != this.bankAccountNumberConfirmation) {
      this.ValidationErrors = true;
      sessionStorage.setItem('autopaydialog', 'error');
      this.auth.SetErrorMessage('Bank Account Number / Confirmation do not match');
      this.openDialog(5);
    }
    else if(!this.AccountType){
      this.ValidationErrors = true;
      sessionStorage.setItem('autopaydialog', 'error');
      this.auth.SetErrorMessage('Account Type (Checking/Savings) is Missing');
      this.openDialog(5);
    }
    // else if(!this.AutopayType){
    //   this.ValidationErrors = true;
    //   sessionStorage.setItem('autopaydialog', 'error');
    //   this.auth.SetErrorMessage('Digital Type (Yes/No) is Missing');
    //   this.openDialog(5);
    // }
    // else if(!this.routingValid){
    //   this.ValidationErrors = true;
    //   sessionStorage.setItem('autopaydialog', 'error');
    //   this.auth.SetErrorMessage('Routing Number is Invalid');
    //   this.openDialog(5);
    // }
    // else if(!this.accountValid){
    //   this.ValidationErrors = true;
    //   sessionStorage.setItem('autopaydialog', 'error');
    //   this.auth.SetErrorMessage('Bank Account Number is Invalid');
    //   this.openDialog(5);
    // }
    else{
      this.ValidationErrors = false;
      this.AutopayType = this.bankProfileForm.get('AutopayType').value;
      if(this.pymtOption === 'AI'){
        this.AutopayType = 'true';
      }
      else{
        this.AutopayType = 'false';
      }
      if(this.bankAccountNumber === this.maskedBankAccountNumber)
      {
        this.bankAccountNumber = this.unmaskedAccountNumber;
        this.bankAccountNumberConfirmation = this.unmaskedAccountNumber;
      }
      this.onAutoPayEditSubmit();
    }
   }

   onAutoPaySignUpSubmit(){
    this.AccountType = this.bankProfileForm.value["AccountType"] === 'C'
    ? 'CONSUMER_CHECKING'
    : this.bankProfileForm.value["AccountType"] === 'S'
      ? 'CONSUMER_SAVINGS'
        : '';
    

    if(this.bankAccountNumber === this.maskedBankAccountNumber)
    {
      this.bankAccountNumber = this.unmaskedAccountNumber;
      this.bankAccountNumberConfirmation = this.unmaskedAccountNumber;
    }
    for (var i = 0; i < this.contractNumberList.length; i++) {
        this.AutoPaySignUpBean = new AutoPaySignUpBeanList();
        this.AutoPaySignUpBean.thirdPartyId = this.thirdPartyNumber;
        this.AutoPaySignUpBean.primaryCustomerAgreementNumber = this.contractNumberList[i].contractNumber.slice(0, -3);;
        this.AutoPaySignUpBean.primaryCustomerScheduleNumber = this.contractNumberList[i].scheduleNumber.toString();
        this.AutoPaySignUpBean.effectiveDate =  this.contractNumberList[i].effectiveDate;
        this.AutoPaySignUpBean.bankAccountNum= this.bankAccountNumber;
        this.AutoPaySignUpBean.bankRoutingNum= this.routingNumber;
        this.AutoPaySignUpBean.accountName =this.nameOnBankAccount;
        this.AutoPaySignUpBean.finAcctType=this.AccountType;
        this.AutoPaySignUpBean.autoInvoiceFlag=this.AutopayType;
        this.AutoPaySignUpBean.email = this.emailAddress;
        this.autoPaySignUpBeanList.push(this.AutoPaySignUpBean);
      }
      this.AutopayConfirmRequest={};
    this.AutopayConfirmRequest = {
      ciamId: this.ciamId,
      ciamAZCode: this.token,
      emailAddress : this.emailAddress,
      autoPaySignUpBeanList: this.autoPaySignUpBeanList
    }
    this.tableLoaded = false; //Spinner enabler
    this.auth.setAutoPayAndBankProfile(this.AutopayConfirmRequest).subscribe(res => {
      this.tableLoaded = true; //Spinner disabled
      if (res.statusMessage === 'SUCCESS') {
        sessionStorage.setItem('autopaydialog', 'four');
        this.openDialog(4);
      }
      else{
        sessionStorage.setItem('autopaydialog', 'error');
        this.auth.SetErrorMessage('An unexpected error occurred. If you need any assistance with your account(s) please call Customer Service at 800-222-4221 or Fleet Services at 877-294-9679.');
        this.openDialog(5);
      }
    }); 
   }

   onAutoPayEditSubmit(){
    if(this.ValidationErrors === false){
      this.AutopayConfirmRequest={};
      this.AutopayConfirmRequest = {
        thirdPartyId: this.thirdPartyNumber,
        billingId:this.billingId,
        primaryCustomerAgreementNumber: this.contractNumberList[0].contractNumber.slice(0, -3),
        primaryCustomerScheduleNumber: this.contractNumberList[0].scheduleNumber,
        effectiveDate: this.contractNumberList[0].effectiveDate,
        bankAccountNum: this.bankAccountNumber,
        bankRoutingNum : this.routingNumber,
        accountName : this.nameOnBankAccount,
        finAcctType: this.AccountType,
        bankName: this.bankName,
        autoInvoiceFlag : this.AutopayType,
        email : this.emailAddress,
        ciamId: this.ciamId,
        ciamAZCode: this.token,
        }
      this.tableLoaded = false; //Spinner enabler
      this.tableLoaded = true; //Spinner enabler
      this.auth.editAutoPayAndBankProfile(this.AutopayConfirmRequest).subscribe(res => {
        if (res.statusMessage === 'SUCCESS') {
          sessionStorage.setItem('autopaydialog', 'four');
          this.openDialog(4);
        }
        else{
          sessionStorage.setItem('autopaydialog', 'error');
          this.auth.SetErrorMessage('An unexpected error occurred. If you need any assistance with your account(s) please call Customer Service at 800-222-4221 or Fleet Services at 877-294-9679.');
          this.openDialog(5);
        }
      });
    }
   }

   onAutoPayTerminateSubmit(){
    this.AutopayTerminateRequest={};
    for (var i = 0; i < this.contractNumberList.length; i++) {
      this.AutoPaySignUpBean = new AutoPaySignUpBeanList();
      this.AutoPaySignUpBean.thirdPartyId = this.thirdPartyNumber;
      this.AutoPaySignUpBean.billingId = this.billingId;
      this.AutoPaySignUpBean.primaryCustomerAgreementNumber = this.contractNumberList[i].contractNumber.slice(0, -3);
      this.AutoPaySignUpBean.primaryCustomerScheduleNumber = this.contractNumberList[i].scheduleNumber.toString();
      this.AutoPaySignUpBean.effectiveDate =  this.contractNumberList[i].effectiveDate;
      this.autoPaySignUpBeanList.push(this.AutoPaySignUpBean);
    }
    this.AutopayTerminateRequest = {
    emailAddress : this.emailAddress,
    ciamId: this.ciamId,
    ciamAZCode: this.token,
    autoPaySignUpBeanList: this.autoPaySignUpBeanList
  }
  this.tableLoaded = false; //Spinner enabler
    this.auth.deleteAutoPayAndBankProfile(this.AutopayTerminateRequest).subscribe(res => {
      this.tableLoaded = true; //Spinner disabled
      if (res.statusMessage === 'SUCCESS') {
        sessionStorage.setItem('autopaydialog', 'seven');
        this.openDialog(7);
      }
      else{
        sessionStorage.setItem('autopaydialog', 'error');
        this.auth.SetErrorMessage('An unexpected error occurred. If you need any assistance with your account(s) please call Customer Service at 800-222-4221 or Fleet Services at 877-294-9679.');
        this.openDialog(5);
      }
    }); 
   }

  openDialog(num:any): void {
        if(num===1){
          sessionStorage.setItem('autopaydialog', 'one');
        }
        if(num===5){
          sessionStorage.setItem('autopaydialog', 'error');
        }
        if(num === 6){
          sessionStorage.setItem('autopaydialog', 'six');
        }
      let dialogRef = this.dialog.open(AutoPayPopupDialogComponent, {
        maxWidth: '200vw',
        width: '500px',
      });

      dialogRef.afterClosed().subscribe(result => {
        if(num===1){
          sessionStorage.setItem('autopaydialog', 'two');
          this.selectBankProfile = true;
        }
        if(num ===2){
          sessionStorage.setItem('autopaydialog', 'three');
          this.openDialog(3);
        }
        if(num ===3){
          sessionStorage.setItem('autopaydialog', 'four');
          this.selectBankVerification=true;
        }
        if(num ===4){
        }
        if(num===5){
          sessionStorage.setItem('autopaydialog', 'error');
        }
        if(num===6){
          let skipterminate  = sessionStorage.getItem('skipterminate');
          if(skipterminate != 'yes'){
            this.onAutoPayTerminateSubmit();
          }
        }
      });
  }

  verifyAccountNumber(event: Event){
    this.AccountType = this.bankProfileForm.get('AccountType').value;

    if(!this.AccountType){
      this.ValidationErrors = true;
      this.bankProfileForm.controls['bankAccountNumber'].setValue('');
      sessionStorage.setItem('autopaydialog', 'error');
      this.auth.SetErrorMessage('Account Type is Missing');
      this.openDialog(5);
    }

    this.accountValid = false;
    this.tableLoaded = false; //Spinner enabler


      const validateBankReq = {
        "accountNumber": this.bankProfileForm.value["bankAccountNumber"],
         "routingNumber": this.bankProfileForm.value["routingNumber"],
         "type": this.bankProfileForm.value["AccountType"] === 'C'
           ? 'CHECKING'
           : this.bankProfileForm.value["AccountType"] === 'S'
             ? 'SAVINGS'
             : ''
       }
        this.tableLoaded = false;
        this.auth.validateBank(validateBankReq).subscribe(res => {
          this.tableLoaded = true; //Spinner disabled
          if(res.status==='SUCCESS')
          {
            this.accountValid = true;
          }
          else{
            sessionStorage.setItem('autopaydialog', 'error');
            this.auth.SetErrorMessage('There is an issue with the Account Number provided');
            this.openDialog(5);
            this.translate.get('LoginModal.VerifyUserIDError').subscribe((data: any) => {
              this.serviceErrorDesc = data;
            });
            this.serviceErrorOccurred = true;
            setTimeout(() => {
              this.serviceErrorOccurred = false;
            }, 7000);  //2s
          }
        });
  }

  getRoutingNumber(event: Event) {
    this.routingValid=false;
    this.bankName = '';
    let routingNumber = this.bankProfileForm.get('routingNumber').value;
    this.tableLoaded = false; //Spinner enabler
    const request = {
     "routingNumber" : routingNumber
    }
    this.auth.getBankName(request).subscribe(res => {
      this.tableLoaded = true; //Spinner disabled
      if(res == null || res.bank_name == null){
        this.bankProfileForm.controls['bankName'].setValue('');
        sessionStorage.setItem('autopaydialog', 'error');
        this.auth.SetErrorMessage('There is an issue with the routing number provided');
        this.openDialog(5);
        this.translate.get('LoginModal.VerifyUserIDError').subscribe((data: any) => {
          this.serviceErrorDesc = data;
        });
        this.serviceErrorOccurred = true;
        setTimeout(() => {
          this.serviceErrorOccurred = false;
        }, 7000);  //2s
      }else{
        this.routingValid=true;
        this.bankName = res.bank_name;
        this.bankProfileForm.controls['bankName'].setValue(res.bank_name);
      }
  });
  }

  getBankProfileDetailsforAutopayAccounts(page: any){
    this.getBankProfileDetailsforAutopayAccountsRequest = {};
    let contractList = [];
    for (var i = 0; i < this.contractNumberList.length; i++)
      {
        let contract = this.contractNumberList[i].contractNumber;
        contractList.push(contract); 
      }
    this.getBankProfileDetailsforAutopayAccountsRequest = {
      signUp : this.signUp,
      editFlag: this.editFlag,
      selectedAccounts: contractList,
      ciamId: this.ciamId,
      ciamAZCode: this.token
    };
    this.tableLoaded = false; //Spinner enabler
    this.auth.getBankProfileDetailsforAutopayAccounts(this.getBankProfileDetailsforAutopayAccountsRequest).subscribe(res => {
      this.tableLoaded = true; //Spinner enabler
      if (res.statusMessage === 'SUCCESS') {
        if(page === 'signup'){
          if(res.bankingProfileList.length > 0){
          this.routingNumber =  res.bankingProfileList[0].bankRoutingNum;
          this.unmaskedAccountNumber=res.bankingProfileList[0].bankAccountNum;
          this.maskedBankAccountNumber = res.bankingProfileList[0].maskedBankAccountNum;
          this.bankName = res.bankingProfileList[0].bankName;
          this.bankAccountNumber =res.bankingProfileList[0].maskedBankAccountNum;
          this.nameOnBankAccount =res.bankingProfileList[0].accountName;
          this.bankAccountNumberConfirmation = res.bankingProfileList[0].maskedBankAccountNum;
          this.AccountType = res.bankingProfileList[0].bankAccountType;
          this.DisplayAccountType =  this.AccountType.replace(/_/g, ' ');
          }
          this.openDialog(1);
        }
        else if(page ==='edit'){
          if(res.bankingProfileList.length > 0){
          this.routingNumber =  res.bankingProfileList[0].bankRoutingNum;
          this.billingId = res.bankingProfileList[0].billingID;
          this.unmaskedAccountNumber=res.bankingProfileList[0].bankAccountNum;
          this.maskedBankAccountNumber = res.bankingProfileList[0].maskedBankAccountNum;
          this.bankName = res.bankingProfileList[0].bankName;
          this.bankAccountNumber =res.bankingProfileList[0].maskedBankAccountNum;
          this.nameOnBankAccount =res.bankingProfileList[0].accountName;
          this.bankAccountNumberConfirmation = res.bankingProfileList[0].maskedBankAccountNum;
          this.AccountType = res.bankingProfileList[0].bankAccountType;
          this.DisplayAccountType =  this.AccountType.replace(/_/g, ' ');
          for (var i = 0; i < res.agreementDetailsList.length; i++) {
            if(contractList[0] === res.agreementDetailsList[i].agreementNumber){
              this.pymtOption = res.agreementDetailsList[i].pymtOption;
              if(this.pymtOption === 'AI'){
                this.displaypymtOption = 'yes';
              }
              else{
                this.displaypymtOption = 'no';
              }
            }
          }
          this.openDialog(1);
          }
          // this.selectBankProfile = true;
          this.selectBankVerification = true;
        }
        if(page ==='terminate'){
          for (var i = 0; i < this.contractNumberList.length; i++) {
            this.billingId = res.bankingProfileList[0].billingID;
            let contract = this.contractNumberList[i].contractNumber;
            this.displaycontractNumberList+= (contract + ', ');
          }
          this.selectTerminate = true;
          this.selectBankProfile=true;
        }
      }
    }); 
  }

  //backstep from edit to autopay page
  backstep1(){
    this.SelectAutopay = true;
    this.SelectAutopaySignup = false;
    this.SelectAutopayTerminate = false;
    this.SelectAutopayEdit = false;

    this.selectedAutopayState = null;
  }

  //backstep from address to edit account page
  backstep2edit(){
    this.SelectAutopay = true;
    this.SelectAutopayEdit = true;
    this.selectBankProfile = false;

    setTimeout(()=>{
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.filterPredicate = function(data, filter: string): boolean {
        return data.agreementNumber.toLowerCase().includes(filter) || data.effectiveDate.toLowerCase().includes(filter);
      };
      this.dbLoaded = true;
      this.filter = true;
      this.rowCount = this.dataSource.filteredData.length;
  });
   
  }

  //backstep from address to terminate account page
  backstep2terminate(){
    this.SelectAutopay = true;
    this.SelectAutopayTerminate = true;
    this.selectBankProfile = false;
    this.selectTerminate = false;

    setTimeout(()=>{
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.filterPredicate = function(data, filter: string): boolean {
        return data.agreementNumber.toLowerCase().includes(filter) || data.effectiveDate.toLowerCase().includes(filter);
      };
      this.dbLoaded = true;
      this.filter = true;
      this.rowCount = this.dataSource.filteredData.length;
  });

  }

  //backstep from address to signup account page
  backstep2signup(){
    this.SelectAutopay = true;
    this.SelectAutopaySignup = true;
    this.selectBankProfile = false;

    setTimeout(()=>{
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.filterPredicate = function(data, filter: string): boolean {
        return data.agreementNumber.toLowerCase().includes(filter) || data.effectiveDate.toLowerCase().includes(filter);
      };
      this.dbLoaded = true;
      this.filter = true;
      this.rowCount = this.dataSource.filteredData.length;
  });
  }

}


@Component({
    selector: 'dialog-autoPayPopup',
    imports: [MatButtonModule,MatDialogContent, MatDialogActions,
        MatDialogClose],
    templateUrl: 'autoPayPopupDialog.component.html'
})
export class AutoPayPopupDialogComponent {
  usUrl: string;
  caUrl: string;
  autopaydialog: string;
  errorMessage: string;
  contractNumberList: ContractNumberRequest[];

  constructor(router: Router, private dtfhomepageService: DTFHomepageService, private fb: FormBuilder, public auth: AuthorizationService,
    private _window: WindowRef, public translate: TranslateService, public translateUtil: TranslateUtil

  ) {
    this.contractNumberList = [];
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
    this.autopaydialog = sessionStorage.getItem('autopaydialog');
    this.auth.cast2.subscribe((results:any)=> {
      this.contractNumberList = results;
     });
     this.auth.cast3.subscribe((errorMessage:any)=> {
      this.errorMessage = errorMessage;
     });
  }

autoPayRedirect(e: Event) {
  sessionStorage.setItem('skipterminate', 'yes');
    let redirect = '';
    this.translate.get('LoginModal.AutoPayRedirect').subscribe((data:any)=> {
      redirect= this.usUrl +  data;
     });
     window.location.href = redirect;
  }
}

